module.exports = __webpack_public_path__ + "static/img/r2.3bab9de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/service/r2.png
// module id = aXng
// module chunks = 1